// extracted by mini-css-extract-plugin
export default {"wrapper":"SharedLayout_wrapper__mfdu9"};